
















































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Game} from "@/models/Game";
import {Player} from "@/models/Player";

@Component
export default class EndScreen extends Vue {
    @Prop()
    showEndScreen: boolean;

    @Prop()
    game: Game;

    get bestPlayer() {
        let bestPlayer = this.game.players[0];
        this.game.players.forEach(player => {
            if (bestPlayer.score < player.score) {
                bestPlayer = player;
            }
        })
        return bestPlayer;
    }

    private headers = [
        {text: 'Name', value: 'name'},
        {text: 'Punkte', value: 'score'},
    ]

    private resetGame() {
        this.$emit('reset-game');
    }
}
